__turbopack_context__.v({
  "time": "Time-module__XkQZyG__time",
});
